<template>
  <footer class="footer">
    <span>{{ __('APoint Systems') }}</span>
  </footer>
</template>

<style scoped>

  .footer {
    display: flex;
    align-items: center;

    padding: 10px 0;
  }

  .footer::after,
  .footer::before {
    content: '';

    flex: 1;

    height: 1px;

    border: 1px solid white;
    border-left: none;
    border-right: none;
  }

  .footer span {
    margin: 0 10px;

    color: white;
    line-height: .9;
    font-size: 15px;
  }

</style>